import React from 'react';
// extra svg components
import UpgradedAssessmentOption from './upgradedAssessmentOption.Component';

const UpgradedQuestionCollection = props => {
    function renderAnswerOptions(key) {
        return (
          <UpgradedAssessmentOption
            key={key.AnswerCopy}
            answerContent={key.AnswerCopy}
            answerType={key.id}
            icon={key.Icon}
            // icon={answerEmojis[key.id]}
            answer={props.answer}
            questionId={props.questionId}
            // onAnswerSelected={props.onAnswerSelected}
            // prop for number of current qn
            displayOrder = {key.DisplayOrder}
            currentQuestion = {props.currentQuestion}
            sliderValue = {props.sliderValue} 
          />
        );
    }
    return (
      <div className="quiz" style={{ width: "100%", alignSelf:"center"}}>        
        <ul className="answerOptions">
          {props.answerOptions.map(renderAnswerOptions)}
        </ul>
      </div>
    );
}

export default UpgradedQuestionCollection;


// WEBPACK FOOTER //
// ./src/common/upgradedQuestionCollection.Component.tsx